/**
 * Track events using CleverTap
 * @param {string} eventName - Name of the event to track
 * @param {object} eventProperties - Properties/metadata for the event
 */
import clevertap from "clevertap-web-sdk";

/**
 * Format a date value for CleverTap.
 * CleverTap Web SDK requires Date objects for date profile properties.
 * @param {string|number|Date} value - The date value to format
 * @returns {Date|null} - A valid Date object, or null if the value is falsy/invalid
 */
export const formatCleverTapDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
};

export const trackEvent = (eventName, eventProperties = {}) => {
  try {
    if (clevertap && clevertap.event && clevertap.event.push) {
      clevertap.event.push(eventName, eventProperties);
    } else {
      console.warn("[CleverTap] CleverTap is not initialized. Event not tracked:", eventName);
    }
  } catch (error) {
    console.error("[CleverTap] Error tracking event:", eventName, error);
  }
};

/**
 * Set user profile properties in CleverTap on user login
 * @param {object} userProperties - User profile data (must include at least one of: Identity, Email, or FBID)
 */
export const userLogin = (userProperties = {}) => {
  try {
    if (clevertap && clevertap.onUserLogin && clevertap.onUserLogin.push) {
      const defaultMsgPreferences = {
        "MSG-email": true,
        "MSG-push": true,
        "MSG-sms": true,
        "MSG-whatsapp": true,
      };

      const profileData = {
        ...defaultMsgPreferences,
        ...userProperties,
      };

      clevertap.onUserLogin.push({
        Site: profileData,
      });
    } else {
      console.warn("[CleverTap] CleverTap is not initialized. User login not done.");
    }
  } catch (error) {
    console.error("[CleverTap] Error setting user login:", error);
  }
};

/**
 * Update user profile properties in CleverTap
 * @param {object} profileProperties - User profile data to update
 * @example
 *
 */
export const updateUserProfile = (profileProperties = {}) => {
  try {
    if (clevertap && clevertap.profile && clevertap.profile.push) {
      clevertap.profile.push({
        Site: profileProperties,
      });
    } else {
      console.warn("[CleverTap] CleverTap is not initialized. Profile not updated.");
    }
  } catch (error) {
    console.error("[CleverTap] Error updating user profile:", error);
  }
};

/**
 * Common events tracker
 */
export const CleverTapEvents = {
  // User Authentication Events
  USER_LOGIN: "Login",
  USER_SIGNUP: "Sign Up",
  USER_LOGOUT: "Logout",

  // Search Events
  GLOBAL_SEARCH: "Global Search",
  SEARCH_RESULT_CLICKED: "Search Result Clicked",

  // Landing Page Events
  COUNSELLING_LANDING_PAGE: "Counselling Landing Page",
  GET_THE_APP_CLICKED: "Get The App",
  LANDING_BLOG_VIEW_PAGE: "View Blog",
  VIEW_BLOG_CATEGORY: "View Blog Category",

  // Package Events
  VIEW_PACKAGES: "View Packages",
  VIEW_PACKAGE_DETAILS: "View Package Details",
  GET_PACKAGE: "Get a Package",
  PROCEED_TO_PAYMENT: "Proceed To Payment",
  TRANSACTION_COMPLETED: "Charged",

  // View Institute
  VIEW_INSTITUTE: "View Institute",

  // Portal Features Events
  VIEW_SEAT_MATRIX: "View Seat Matrix",
  VIEW_ALLOTMENTS: "View Allotment",
  VIEW_CLOSING_RANKS: "View Closing Ranks",
  VIEW_FEE_STIPEND_BOND: "View Fee, Stipend & Bond",

  // Choice List Events
  CREATE_CHOICE_LIST: "Create Choice List",

  //Explore Searches
  // SEARCH_INSTITUTE: "Search Institute",
  // SEARCH_UNIVERSITY: "Search University",
  // SEARCH_COUNSELLING: "Search Counselling",
  // SEARCH_COURSE: "Search Course",
};
